import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import SuccessIcon from 'assets/images/done-green.svg';
import ErrorIcon from 'assets/images/close-circle-red.svg';
import ErrorSymbol from 'assets/images/error.svg';
import LoadingGif from 'assets/images/spinner-144x144px.gif';
import CloseIcon from '@mui/icons-material/Close';
import style from './style';
import { globalStyles } from 'shared/constants';

const ToastDialog = ({
  content = null,
  contentText = 'Success! Your new product has been added.',
  contentVariant = 'h6',
  heading = 'New Product Added',
  isLoading = false,
  onClose = null,
  open = false,
  isError = false,
  contentAction = false,
  contentActionText = '',
  customIcon = null,
  status = '',
}) => {
  const ButtonText = status === 'Error' ? 'Close' : 'Home';
  return (
    <Dialog
      sx={{
        ...style.toastDialog
      }}
      open={open}
      onClose={onClose}
      centered
    >
      <DialogTitle>
        <Box
          sx={{ ...style.closeIcon, ...globalStyles.cursor.pointer }}
        >
          <CloseIcon onClick={onClose} />
        </Box>
        <Typography variant='h5' sx={{ ...globalStyles.padding(2, 'Top'), ...globalStyles.text.weight.bold, ...globalStyles.text.align.center, ...globalStyles.text.color.default, ...style.fontRoboto }}>
          {heading}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ ...globalStyles.padding(0, 'Top'), ...style.fontRoboto }}>
        {content ? (
          <>{content}</>
        ) : (
          <Box sx={{ ...globalStyles.padding(2, 'Top'), ...globalStyles.text.align.center}}>
            {isLoading ? (
              <IconButton disabled sx={{ ...globalStyles.margin(4, 'Top'), ...globalStyles.margin(4, 'Bottom')}}>
                <img
                  src={LoadingGif}
                  alt='Success Icon'
                />
              </IconButton>
            ) : (
              <IconButton disabled sx={{ ...globalStyles.margin(1, 'Top'), ...globalStyles.margin(1, 'Bottom')}}>
                <img
                  src={
                    customIcon ||
                    (isError
                      ? status === 'Error'
                        ? ErrorSymbol
                        : ErrorIcon
                      : SuccessIcon)
                  }
                  alt='Success Icon'
                  width='96'
                />
              </IconButton>
            )}
            <Typography
              sx={{
                ...globalStyles.margin(1, 'Top'),
                ...globalStyles.margin(1, 'Bottom'),
                ...style.fontRoboto,
                // ...(isError ? globalStyles.text.color.error : {}),
                ...(isError ? style.colorError : {}),
                ...(!isError ? style.successText : {})
              }}
              variant={contentVariant}
            >
              {contentText}
            </Typography>
            {(status === 'Error' || status === 'Success') && (
              <Typography variant='body2' sx={{ ...globalStyles.margin(4, 'Top'), ...style.fontRoboto, }}>
                {status === 'Error'
                  ? 'Please review error list for more details on unsynced items.'
                  : status === 'Success'
                  ? 'Would you like to start a new report?'
                  : ''}
              </Typography>
            )}
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ ...globalStyles.flex.align.center }}>
        {contentAction && (
          <Button
            onClick={contentAction || onClose}
            variant='contained'
            color='primary'
            sx={{
              ...globalStyles.margin(2, 'Top'),
              ...globalStyles.margin(2, 'Bottom'),
              ...globalStyles.text.weight.bold,
              ...style.bgPrimary,
              ...style.fontRoboto,
            }}
          >
            {contentActionText || ButtonText}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ToastDialog;
